import Cookies from 'js-cookie';
import { getCookieDomain, DEV_MODE } from './util';
import { DateTime } from 'luxon';
import { REFERRAL_COOKIE_EXPIRATION_HOURS, REFERRAL_COOKIE_NAME, ReferralCookieData } from './util/referralCookie';

export default function setReferralCookie(code: string, name?: string, source?: string) {
  const data: ReferralCookieData = { code, name, source };
  Cookies.set(REFERRAL_COOKIE_NAME, JSON.stringify(data), {
    expires: DateTime.utc().plus({ hours: REFERRAL_COOKIE_EXPIRATION_HOURS }).toJSDate(),
    domain: getCookieDomain(),
    secure: !DEV_MODE,
  });
}
